import React, { useEffect, useState , useRef } from "react";
import { Dropdown,Modal, Button, Spinner, Badge, Row, Col, Form } from "react-bootstrap";
import {  useNavigate } from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import "../ComponentsCss/Nav.css";
import { Bell, LogOut, Key, Info} from "lucide-react";
import { ClipboardList } from 'lucide-react';														
import axios from "axios";
import { OverlayTrigger, Tooltip } from "react-bootstrap"; // Import Tooltip components
import { regionConfig } from "../authConfig";  // Adjust path if needed

import { Settings } from "lucide-react"; // gear icon
import { CheckCircle, XCircle } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Bot , PlayCircle ,Play, CirclePlay } from "lucide-react";
import { useNotification } from "../contexts/NotificationContext";
import SusanChatbot from './SusanChatbot';
 import { useAuth } from "../contexts/AuthContext";
   import { logActivity ,getClientIP } from '../utils/activityLogApi';
																  
										
// Import your logo image here
import logo from "../Assets/SUSAN logo White.png"; // Replace with the correct path to your logo file

import reload from "../Assets/reload.png";


const getRandomDarkColor = () => {
  const calculateLuminance = (r, g, b) => {
    // Normalize RGB values to a scale of 0-1
    const a = [r, g, b].map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  };

  let color;
  let luminance;
  do {
    const letters = "0123456789ABCDEF";
    color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    // Convert hex to RGB
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);

    luminance = calculateLuminance(r, g, b);
  } while (luminance > 0.5); // Luminance threshold for dark colors

  return color;
};

const NavigationBar = ({ signOut, userData , isSidebarCollapsed}) => {
    const { signOut: authSignOut } = useAuth();

    const [selectedRegion, setSelectedRegion] = useState(() => 
    sessionStorage.getItem("userRegion") || "GB"
  );
  // Accept userData as a prop
  const [userAttributes, setUserAttributes] = useState({
    email: "",
    username: "",
  });

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [moduleToReset, setModuleToReset] = useState("");
  const [isResetting, setIsResetting] = useState(false);
 
																	 
  const [showDashboardResetModal, setShowDashboardResetModal] = useState(false);
const [notifications, setNotifications] = useState([]);
const [requesterNotifications, setRequesterNotifications] = useState([]); 
const [totalNotificationCount, setTotalNotificationCount] = useState(0);
const [notificationPermission, setNotificationPermission] = useState('default');
const [showNotificationModal, setShowNotificationModal] = useState(false);
const [activeTab, setActiveTab] = useState('pending'); // 🚀 ADD THIS
// Add org subscription states
const [orgSubscriptionStatus, setOrgSubscriptionStatus] = useState(null);
const [orgTrialEndDate, setOrgTrialEndDate] = useState(null);
const [secondTrialAvailable, setSecondTrialAvailable] = useState(false);
const [subscriptionLoading, setSubscriptionLoading] = useState(true);
const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
const [subscriptionKey, setSubscriptionKey] = useState('');
const [isActivatingKey, setIsActivatingKey] = useState(false);
const [keyValidationError, setKeyValidationError] = useState('');
const [keyValidationInfo, setKeyValidationInfo] = useState(null);
const [isValidatingKey, setIsValidatingKey] = useState(false);
const validationTimeout = useRef(null); // Add this line
// Add these states in your NavigationBar component
const [firstTrialUsed, setFirstTrialUsed] = useState(false);
const [secondTrialUsed, setSecondTrialUsed] = useState(false);

const [showVideoModal, setShowVideoModal] = useState(false);
const [showDemoForm, setShowDemoForm] = useState(false);

const [sending, setSending] = useState(false);
  const [showQBotModal, setShowQBotModal] = useState(false);

const [helpMessage, setHelpMessage] = useState("");
    const [expandedIndex, setExpandedIndex] = useState(null);						 
										 
const [formData, setFormData] = useState({
  name: "",
  email: "",
  company: "",
  message: "",
});						

const { profile } = useAuth();
const orgId = profile?.orgId;

    const {
        emailNotificationEnabled,
        setEmailNotificationEnabled,
        pushNotificationEnabled,
        setPushNotificationEnabled,
        userPhoneNumber,
        setUserPhoneNumber,
        validatePhoneNumber,
        lastNotificationSent,
        sendCriticalRiskNotification
    } = useNotification();





 const userId = userData?.["cognito:username"] ;
  const role = userData?.["cognito:groups"];
  const navigate = useNavigate();
const [clientIP, setClientIP] = useState('');
useEffect(() => {
  getClientIP().then(ip => setClientIP(ip || '')).catch(() => setClientIP(''));
}, []);
		const saveNotificationsApiBase = () => {
  return "https://x5c0kgyiqb.execute-api.ap-southeast-2.amazonaws.com/prod";
};			

	const getNotificationsApiBase = () => {
  return "https://qfccz4a0k7.execute-api.ap-southeast-2.amazonaws.com/prod";
};	
													   
  const getUpdatePhoneAPI = () => {
  return 'https://nk4nrvvu49.execute-api.ap-southeast-2.amazonaws.com/prod';
};

const getUserRegion = () => sessionStorage.getItem("userRegion") || "GB";
 
// Save notification settings to backend
const saveNotificationSettings = async (overrides = {}) => {
  if (!userId) return;

  const region = getUserRegion();

  const payload = {
    emailEnabled: overrides.emailEnabled ?? emailNotificationEnabled,
    smsEnabled: overrides.smsEnabled ?? pushNotificationEnabled,
    phoneNumber: overrides.phoneNumber ?? userPhoneNumber,
    lastNotificationSent: lastNotificationSent?.timestamp || 0,
  };

  try {
    await axios.post(
      `${saveNotificationsApiBase()}/api/notifications/settings/${userId}`,
      payload,
      {
        headers: { Region: region },
      }
    );
    // Optional toast if you want
    // setToastMessage("Notification preferences saved");
    // setShowToast(true);
  } catch (error) {
    console.error("Failed to save notification settings:", error);
    // You can keep it silent or show a toast
  }
};



const handlePhoneNumberAction = async () => {
  const storedPhone = localStorage.getItem("userPhoneNumber");  

  let ok = false;

  if (storedPhone && storedPhone !== userPhoneNumber) {
    ok = await updatePhoneNumber();
  } else if (!storedPhone) {
    ok = await savePhoneNumber();
  } else {
    setToastMessage("Phone number is already up to date");
    setShowToast(true);
    ok = true;
  }

  if (ok) {
    // Also persist into notification settings table
    saveNotificationSettings({ phoneNumber: userPhoneNumber });
  }

  return ok;
};

 
const [isUpdatingPhone, setIsUpdatingPhone] = useState(false);
 
const sendTestSMS = async () => {
  try {
    const testMessage = `🧪 Test SMS from Security Model: This is a test notification to verify your mobile number. Time: ${new Date().toLocaleString()}`;
   
    const response = await axios.post(
      'https://9925qndwwe.execute-api.ap-southeast-2.amazonaws.com/prod/api/notifications/send-sms',
      null,
      {
        params: {
          message: testMessage,
          userId: userData?.["cognito:username"]
        },
        headers: {
          'Region': getUserRegion()
        }
      }
    );
 
    if (response.status === 200) {
      setToastMessage('✅ Test SMS sent successfully! Check your phone.');
      setShowToast(true);
    }
  } catch (error) {
    console.error('Failed to send test SMS:', error);
    setToastMessage('❌ Failed to send test SMS. Please check your phone number.');
    setShowToast(true);
  }
};
// Update phone number (for existing users)
const updatePhoneNumber = async () => {
  if (!validatePhoneNumber(userPhoneNumber)) {
    setToastMessage('Please enter a valid phone number in international format (e.g., +1234567890)');
    setShowToast(true);
    return false;
  }
 
  setIsUpdatingPhone(true);
  try {
    const response = await axios.put(
      `${getUpdatePhoneAPI()}/user/phone/update`,
      {
        userId: userData?.["cognito:username"],
        phoneNumber: userPhoneNumber
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Region': getUserRegion()
        }
      }
    );
 
    if (response.status === 200) {
      localStorage.setItem('userPhoneNumber', userPhoneNumber);
      setToastMessage('✅ Phone number updated successfully!');
      setShowToast(true);
      return true;
    }
  } catch (error) {
    console.error('Failed to update phone number:', error);
    setToastMessage('❌ Failed to update phone number. Please try again.');
    setShowToast(true);
    return false;
  } finally {
    setIsUpdatingPhone(false);
  }
};

const getPhoneManagementAPI = () => {
  return 'https://kcgr93r1rc.execute-api.ap-southeast-2.amazonaws.com/prod';
};
 
// Save phone number (for new users)
const savePhoneNumber = async () => {
  // Validation
  if (!validatePhoneNumber(userPhoneNumber)) {
    setToastMessage('Please enter a valid phone number');
    return false;
  }
 
  try {
    // 1. Save to database FIRST
    const response = await axios.post(
      `${getPhoneManagementAPI()}/user/phone/save`,
      {
        userId: userData?.["cognito:username"],
        phoneNumber: userPhoneNumber
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Region': getUserRegion()
        }
      }
    );
 
    // 2. Only save to localStorage AFTER successful database save
    if (response.status === 200) {
      localStorage.setItem('userPhoneNumber', userPhoneNumber); // ✅ Correct timing
      setToastMessage('✅ Phone number saved successfully!');
      return true;
    }
  } catch (error) {
    console.error('Failed to save phone number:', error);
    setToastMessage('❌ Failed to save phone number');
    return false;
  }
};
 
 





// Add this function BEFORE the useEffect
const fetchOrgSubscriptionStatus = async () => {


  
  try {
    const region = selectedRegion || sessionStorage.getItem('userRegion') || 'GB';

      const awsCustomerId = getAwsCustomerId();
   

    const orgRes = await fetch(`https://atw24p2ef8.execute-api.ap-southeast-2.amazonaws.com/prod/api/org/subscription-status`, {
      method: 'GET',
      headers: {
        'UserId': userData["cognito:username"], // ✅ Fixed
        'Region': region,
          "AwsCustomerId": getAwsCustomerId() || "",
      }
    });
    
     console.log("📥 Raw response:", orgRes);
    const orgData = await orgRes.json();
     console.log("📦 Parsed subscription data from backend:", orgData);
    
  
    
    // Set states
    setOrgSubscriptionStatus(orgData.status);
    setOrgTrialEndDate(orgData.trialEnd);
    setFirstTrialUsed(orgData.firstTrialUsed || false);
    setSecondTrialUsed(orgData.secondTrialUsed || false);
    setSecondTrialAvailable(!orgData.secondTrialUsed);
  
    
    if (orgData.currentPeriodEnd) {
      setSubscriptionExpiryDate(orgData.currentPeriodEnd);
    }
  } catch (error) {
    console.error('❌ [FETCH ERROR]:', error);
  } finally {
    setSubscriptionLoading(false);
  }
};

useEffect(() => {
  const fetchNotificationSettings = async () => {
    if (!userId) return;

    try {
      const region = getUserRegion();
      const res = await axios.get(
        `${getNotificationsApiBase()}/api/notifications/settings/${userId}`,
        {
          headers: { Region: region },
        }
      );

      const data = res.data;

      if (typeof data.emailEnabled === "boolean") {
        setEmailNotificationEnabled(data.emailEnabled);
      }

      if (typeof data.smsEnabled === "boolean") {
        setPushNotificationEnabled(data.smsEnabled);
      }

      if (data.phoneNumber) {
        setUserPhoneNumber(data.phoneNumber);
        localStorage.setItem("userPhoneNumber", data.phoneNumber);
      }
    } catch (error) {
      console.error("Failed to fetch notification settings:", error);
      // Fallback to defaults from NotificationContext
    }
  };

  fetchNotificationSettings();
}, [userId]);



useEffect(() => {
  fetchOrgSubscriptionStatus();
}, [userData, selectedRegion]); // Add selectedRegion dependency

												
 const getAwsCustomerId = () => {
  return localStorage.getItem("aws_customer_id") || null;
};


useEffect(() => {
  const fetchSubscriptionStatus = async () => {
    if (!userData?.["cognito:username"]) return;
    
    try {
      const region = sessionStorage.getItem("userRegion") || "IN";
      const awsCustomerId = getAwsCustomerId();

      console.log("📡 Calling /org/subscription-status...");
      console.log("🧩 Headers being sent to backend:");
      console.log("   🔹 UserId:", userData["cognito:username"]);
      console.log("   🔹 Region:", region);
      console.log("   🔹 AwsCustomerId:", awsCustomerId);
      // Fetch org subscription status (covers ALL modules)
      const orgRes = await fetch("https://atw24p2ef8.execute-api.ap-southeast-2.amazonaws.com/prod/api/org/subscription-status", {
        method: "GET",
        headers: {
          'UserId': userData["cognito:username"],
          'Region': region,
            "AwsCustomerId": getAwsCustomerId() || "",
        },
      });
        console.log("📥 Raw response:", orgRes);
      const orgData = await orgRes.json();
      setOrgSubscriptionStatus(orgData.status);
      setOrgTrialEndDate(orgData.trialEnd);
      setSecondTrialAvailable(!orgData.secondTrialUsed); // Remove the status check
        console.log("📦 Parsed subscription data from backend:", orgData);
    } catch (error) {
							  
												   
														 

						 
													   

								 
																
								  

	   
				   
      console.error("Failed to fetch subscription status", error);
    } finally {
      setSubscriptionLoading(false);
    }
  };

  fetchSubscriptionStatus();
					  
   
}, [userData]);






useEffect(() => {
  if (userId) {
    // Check current permission status
    if ('Notification' in window) {
      setNotificationPermission(Notification.permission);
    }
    
    // Fetch notifications if permission granted
    if (Notification.permission === 'granted') {
      fetchNotifications();
      const interval = setInterval(fetchNotifications, 30000); // Poll every 30 seconds
      return () => clearInterval(interval);
    }
  }
}, [userId, notificationPermission]);



  useEffect(() => {
    if (userData) {
      // Extract username and email from userData
      const username = userData.name || "No Username";
      const email = userData.email || "No Email";
      setUserAttributes({ email, username });
    }

    const avatarColor = getRandomDarkColor();
    document.documentElement.style.setProperty("--avatar-color", avatarColor);
  }, [userData]);

  // Call the passed-down signOut prop function
   const handleSignOut = async () => {
    try {
      await authSignOut(); // Use signOut from context
      sessionStorage.clear();
      localStorage.clear();
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Error signing out: ", error);
    } finally {
      setIsResetting(false);
    }
  };

  // Add this function after the other handler functions in NavigationBar component
// Org subscription handlers
const handleStartOrgTrial = async () => {
  try {
    const region = sessionStorage.getItem("userRegion") || "IN";
								 
    const response = await fetch("https://7b3mrfutle.execute-api.ap-southeast-2.amazonaws.com/prod/api/billing/start-trial", {
	   
      method: "POST",
      headers: {
        'UserId': userData["cognito:username"],
        'Region': region
		  
      }
    });

									   

    if (response.ok) {
      window.location.reload();
    } else {
      alert('Failed to start trial');
    }
  } catch (err) {
    console.error("Trial start failed", err);
    alert("Failed to start trial");
  }
};


const handleStartSecondTrial = async () => {
  try {
																		   
    const region = sessionStorage.getItem("userRegion") || "IN";
    const response = await fetch("https://80gbnjdo0k.execute-api.ap-southeast-2.amazonaws.com/prod/api/billing/start-second-trial", {
      method: "POST",
      headers: {
        'UserId': userData["cognito:username"],
        'Region': region
			   
      }
    });

   if (response.ok) {
  window.location.reload()
} else {
  const data = await response.json()
  alert(data.error || "Failed to start second trial")
}

  } catch (err) {
    console.error("Second trial failed", err);
    alert("Failed to start second trial");
  }
};

// const handleOrgSubscription = async () => {
//   try {
//     const region = sessionStorage.getItem("userRegion") || "IN";
    
//     // ✅ GET CURRENT PAGE URL TO RETURN TO
//     const currentUrl = window.location.href;
    
//     const response = await fetch(`https://pg7sjiyq94.execute-api.eu-west-1.amazonaws.com/prod/api/billing/checkout-session?returnUrl=${encodeURIComponent(currentUrl)}`, {
//       method: "POST",
//       headers: {
//         'UserId': userData["cognito:username"],
//         'Region': region
//       }
//     });

//     const data = await response.json();
   
    
//     if (data.sessionUrl) {
//       // ✅ PRIORITY: USE THE DIRECT SESSION URL FROM STRIPE
      
//       window.location.href = data.sessionUrl;
//     } else if (data.sessionId) {
//       // ✅ FALLBACK: Try constructing the URL manually
     
//       window.location.href = `https://checkout.stripe.com/c/pay/${data.sessionId}`;
//     } else {
//       console.error('Checkout session creation failed:', data);
//       alert("Failed to create checkout session: " + (data.error || JSON.stringify(data)));
//     }
//   } catch (err) {
//     console.error("Org subscription checkout failed", err);
//     alert("Payment setup failed: " + err.message);
//   }
// };

const handleSubscriptionKeyEntry = () => {
  setShowSubscriptionModal(true);
  setSubscriptionKey('');
  setKeyValidationError('');
};

// const handleActivateSubscriptionKey = async () => {
//   if (!subscriptionKey.trim()) {
//     setKeyValidationError('Please enter a subscription key');
//     return;
//   }

//   setIsActivatingKey(true);
//   setKeyValidationError('');
  
//   try {
//     const region = sessionStorage.getItem("userRegion") || "IN";
//     const response = await fetch("YOUR_API_ENDPOINT/api/subscription/activate-key", {
//       method: "POST",
//       headers: {
//         'Content-Type': 'application/json',
//         'UserId': userData["cognito:username"],
//         'Region': region
//       },
//       body: JSON.stringify({ subscriptionKey: subscriptionKey.trim() })
//     });

//     const data = await response.json();
    
//     if (response.ok) {
//       setShowSubscriptionModal(false);
//       setSubscriptionKey('');
//       setToastMessage('🎉 Subscription activated! Premium features unlocked.');
//       setShowToast(true);
//       window.location.reload();
//     } else {
//       setKeyValidationError(data.error || 'Invalid subscription key. Please check and try again.');
//     }
//   } catch (err) {
//     console.error("Key activation failed", err);
//     setKeyValidationError("Failed to activate subscription key. Please try again.");
//   } finally {
//     setIsActivatingKey(false);
//   }
// };




// const handleManageBilling = async () => {
//   try {
//     const region = sessionStorage.getItem("userRegion") || "IN";
//     const response = await fetch("https://0shbfl9j5a.execute-api.eu-west-1.amazonaws.com/prod/api/billing/portal-session", {
//       method: "POST",
//       headers: {
//         'UserId': userData["cognito:username"],
//         'Region': region
//       }
//     });

//     const data = await response.json();
//     if (data.url) {
//       window.open(data.url, '_blank');
//     }
//   } catch (err) {
//     console.error("Portal failed", err);
//     alert("Could not open billing portal");
//   }
// };
// DELETE the old handleTrialClick function and replace with:
// const handleUnifiedSubscription = async () => {
//   // If no subscription, start trial. If trial expired, go to checkout.
//   if (!orgSubscriptionStatus) {
//     await handleStartOrgTrial();
//   } else if (['past_due', 'canceled'].includes(orgSubscriptionStatus)) {
//     await handleOrgSubscription();
//   } else {
//     await handleManageBilling();
//   }
// };



const handleResetPassword  = async () => {
  try {
    // 🔥 STEP 1: Clear any existing Cognito session
   
    
    // Clear sessionStorage
    sessionStorage.removeItem('amplify-signin-with-hostedUI');
    sessionStorage.removeItem('amplify-cognito-token-refresh');
    
    // Clear localStorage
    localStorage.removeItem('amplify-signin-with-hostedUI');
    localStorage.removeItem('amplify-cognito-token-refresh');
    
    // Clear all Cognito-related cookies
    document.cookie.split(";").forEach(function(c) { 
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    });

    const userRegion = sessionStorage.getItem("userRegion");
  
    
    const authConfig = regionConfig[userRegion];

    if (!authConfig) {
      console.error("No Cognito config found for region:", userRegion);
      alert("Error: Could not determine the authentication region.");
      return;
    }

    // 🔥 STEP 2: Construct clean forgot password URL
     const forgotPasswordUrl = `${authConfig.oauth.domain}/forgotPassword?client_id=${authConfig.aws_user_pools_web_client_id}&redirect_uri=${authConfig.oauth.redirectSignIn}&response_type=token&scope=email+openid+phone+profile`;
 

    // Small delay to ensure cleanup completes
    setTimeout(() => {
      window.location.href = forgotPasswordUrl;
    }, 100);

  } catch (error) {
    console.error("❌ Error:", error);
    alert("An error occurred while resetting the password.");
  }
};


  

  const moduleSubmodulesMap = {
    AWS: [
      'AWSIAM',
      'AWSDetection',
      'AWSInfrastructureProtection',
      'AWSDataProtection',
      'AWSIRAutomation',
    ],
    Entra: [
      'EntraAzureIAM',
      'EntraAzureDetection',
      'AzureInfraProtection',
      'AzureDataProtection',
      'EntraAzureAutomation',
    ],
    GoogleCloud: [
      'GoogleCloudIAM',
      'GoogleCloudDetection',
      'GoogleInfraProtection',
      'GoogleDataProtection',
      'GoogleIRAutomation',
    ],
    M365: [
      'M365IAMMFA',
      'UserAdministration',
      'IntuneEnrollment',
      'GroupPolicies',
      'HybridConnect',
      'CloudMigration',
      'Sentinel',
      'BitLockerEncryption',
      'FirewallManagement',
      'WindowsUserPatching',
      'SSOEntApp',
    ],
    ISO27001Compliance: [
     "Organizational", 
     "People",
     "Physical", 
     "Technological",
    ],
    PrivacyDataProtectionCompliance: [
     "DataAndRiskMgmt",
     "LegalCompliance",
     "PrivacyEngineering", 
     "PrivacyFramework",
     ],
    GenAI: ['GenAI'],  // No submodules
    BlockchainSecurity: ['BlockchainSecurity'], // No submodules
    CISSecurity: ['CISSecurity'], // No submodules
    PS213: ['PS213'],

  };
 
  const handleConfirmResetModule = async () => {
    const submodules =
      moduleToReset === "AllModules"
        ? Object.values(moduleSubmodulesMap).flat()
        : moduleSubmodulesMap[moduleToReset];
      setIsResetting(true);
    try {
      const payload = {
        userId,
        module: moduleToReset,
        submodules,
      };

      const getUserRegion = () => {
        return sessionStorage.getItem("userRegion") || "GB"; // Default to UK
      };

      const response = await axios.post("https://hpup0tic0b.execute-api.ap-southeast-2.amazonaws.com/prod/api/reset-module", payload,
        {
          headers: {
          
            "Region": getUserRegion(), // Include user region dynamically
          },
        }
      
      );

      if (response.status === 200) {
        if (moduleToReset === "AllModules") {
          localStorage.removeItem("responses");
           logActivity({
                      userData,
                      orgId:       orgId,
                      region:      sessionStorage.getItem('userRegion') || 'AP',
                      module:      'Nav',
                      category:    'Reset',
                      action:      'All Modules Reset',
                      
          
                      description: `Modules reset`,
                    ipAddress:   clientIP});
          
        } else {
          const savedResponses = JSON.parse(localStorage.getItem("responses")) || {};
          submodules.forEach((submodule) => delete savedResponses[submodule]);
          localStorage.setItem("responses", JSON.stringify(savedResponses));
        }
        setShowWarningModal(false);
        window.location.reload();
      } else {
        throw new Error("Unexpected response status: " + response.status);
      }
    } catch (error) {
      console.error(`Error resetting module ${moduleToReset}:`, error);
      alert(`Failed to reset module ${moduleToReset}.`);
    }
  };
  
const handleResetDashboard = () => {
  setShowDashboardResetModal(true);
};


						
												  
  
const userName = userData?.name;
  const userEmail = userData?.email;
  const userPhone = userData?.phone_number || "N/A"; // if you're storing phone
  const toggleInsight = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };															 
  

const confirmResetDashboard = async () => {
  setIsResetting(true);
  try {
    const region = sessionStorage.getItem("userRegion") || "IN";
    const userId = userData?.["cognito:username"];

   
    await axios.delete(
      "https://2p53lkl169.execute-api.ap-southeast-2.amazonaws.com/prod/api/cached-ai-insights", // Update with your actual endpoint
      {
        params: { userId },
        headers: { Region: region }
      }
    );

    await axios.delete(
      "https://1rnn3kpsdj.execute-api.ap-southeast-2.amazonaws.com/prod/api/delete-status",
      {
        params: { userId },
        headers: { Region: region },
      }
    );

    localStorage.removeItem("aiInsights");
    localStorage.removeItem("uploadedRisks");

      const storedFullResponse = localStorage.getItem("fullAIResponse");
    if (storedFullResponse) {
      try {
        const parsed = JSON.parse(storedFullResponse);
        if (parsed.assetSection) {
          delete parsed.assetSection;
          localStorage.setItem("fullAIResponse", JSON.stringify(parsed));
            logActivity({
                      userData,
                      orgId:       orgId,
                      region:      sessionStorage.getItem('userRegion') || 'AP',
                      module:      'Nav',
                      category:    'Reset',
                      action:      'Dashboard Reset',
                      
          
                      description: `Dashboard reset`,
                    ipAddress:   clientIP});
          
        
        }
      } catch (err) {
        console.error("❌ Failed to clean assetSection:", err);
      }
    }
    window.location.reload();
  } catch (error) {
    console.error("Failed to reset dashboard:", error);
    alert("Dashboard reset failed. Please try again.");
  } finally {
    setIsResetting(false);
    setShowDashboardResetModal(false);
  }
};

// 🔔 ADD THESE NEW FUNCTIONS:
const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    alert('This browser does not support notifications');
    return;
  }
  try {
    const permission = await Notification.requestPermission();
    setNotificationPermission(permission);
    if (permission === 'granted') {
      fetchNotifications();
    }
  } catch (error) {
    console.error('Notification permission request failed:', error);
  }
};

const fetchNotifications = async () => {
  try {
    const region = sessionStorage.getItem("userRegion");
    
    // Fetch pending requests (for invited user)
    const pendingResponse = await axios.get(
      "https://nlwttpm9v2.execute-api.ap-southeast-2.amazonaws.com/prod/api/pending/all-regions",
      {
        params: { invitedUserId: userId },
        headers: { Region: region }
      }
    );
    
    // 🚀 NEW: Fetch requester notifications (approval/denial notifications)
    const notificationResponse = await axios.get(
      "https://k4sz8vrvk1.execute-api.ap-southeast-2.amazonaws.com/prod/api/notifications", // Update with your actual API
      {
        params: { userId: userId },
        headers: { Region: region }
      }
    );
    
    const pendingRequests = pendingResponse.data.data || [];
    const statusNotifications = notificationResponse.data.notifications || [];
    
    setNotifications(pendingRequests);
    setRequesterNotifications(statusNotifications);
    
    // Calculate total count
    const totalCount = pendingRequests.length + statusNotifications.filter(n => n.status === 'unread').length;
    setTotalNotificationCount(totalCount);
    
    // Show browser notification for new updates
    if (totalCount > 0 && notificationPermission === 'granted') {
      new Notification(`🔔 ${totalCount} New Notification${totalCount > 1 ? 's' : ''}`, {
        body: `${pendingRequests.length} pending requests, ${statusNotifications.filter(n => n.status === 'unread').length} status updates`,
        icon: '/favicon.ico'
      });
    }
    
  } catch (error) {
    console.error('❌ Failed to fetch notifications:', error);
  }
};

// 🚀 ADD function to mark notification as read
const markNotificationAsRead = async (notificationId) => {
  try {
    const region = sessionStorage.getItem("userRegion");
  
					 
			 
			
	   
    
    const response = await axios.put(
      `https://ff8raiuc47.execute-api.ap-southeast-2.amazonaws.com/prod/api/notifications/${notificationId}/read`,
      {}, // Empty body for PUT request
      {
        params: { userId: userId },
        headers: { 
          Region: region,
          'Content-Type': 'application/json' // 🚀 ADD THIS
        }
      }
    );
    
  
    
    // Refresh notifications
    await fetchNotifications();
    
  } catch (error) {
    console.error('❌ Failed to mark notification as read:', error);
    console.error('❌ Error details:', error.response?.data);
    
    // 🚀 ADD ALERT TO SEE ERROR
    alert(`Failed to mark notification as read: ${error.message}`);
  }
};


const handleApproveRequest = async (request) => {
  try {
    const region = sessionStorage.getItem("userRegion") || "IN";
    await axios.put(
      "https://li78m69zsb.execute-api.ap-southeast-2.amazonaws.com/prod/api/approve",
      {},
      {
        params: { 
          invitedUserId: request.invitedUserId,
          requesterUserId: request.requesterUserId
        },
        headers: { Region: region }
      }
    );
    
    fetchNotifications(); // Refresh notifications
    
    if (notificationPermission === 'granted') {
      new Notification('✅ Access Request Approved', {
        body: `Access granted to ${request.requesterEmail}`,
        icon: '/favicon.ico'
      });
    }
  } catch (error) {
    console.error('❌ Failed to approve request:', error);
    alert('Failed to approve request. Please try again.');
  }
};

const handleDenyRequest = async (request) => {
  try {
    const region = sessionStorage.getItem("userRegion");
    await axios.put(
      "https://v7wrf3491l.execute-api.ap-southeast-2.amazonaws.com/prod/api/deny",
      {},
      {
        params: { 
          invitedUserId: request.invitedUserId,
          requesterUserId: request.requesterUserId
        },
        headers: { Region: region }
      }
    );
    
    fetchNotifications(); // Refresh notifications
    
    if (notificationPermission === 'granted') {
      new Notification('❌ Access Request Denied', {
        body: `Access denied to ${request.requesterEmail}`,
        icon: '/favicon.ico'
      });
    }
  } catch (error) {
    console.error('❌ Failed to deny request:', error);
    alert('Failed to deny request. Please try again.');
  }
};


  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
   const handleResetModule = (module) => {
    setModuleToReset(module);
    setShowWarningModal(true);
  };

  const handleCancelReset = () => {
    setShowWarningModal(false);
    setModuleToReset("");
  };
// Add this function to validate the key format on the frontend
const isValidKeyFormat = (key) => {
  if (!key || key.trim() === '') return false;
  
  // Validate the new format: SUS-[COUNTRY]-[RANDOM]-[DOMAIN]-[16-20 DIGITS]
  const keyPattern = /^SUS-[A-Z]{2}-\d{4,6}-[a-zA-Z0-9]+-\d{16,20}$/;
  return keyPattern.test(key.trim());
};

// Updated activation handler
const handleActivateSubscriptionKey = async () => {
  if (!subscriptionKey.trim()) {
    setKeyValidationError('Please enter a subscription key');
    return;
  }

  if (!isValidKeyFormat(subscriptionKey)) {
    setKeyValidationError('Invalid key format. Please check your subscription key.');
    return;
  }

  setIsActivatingKey(true);
  setKeyValidationError('');

  try {
    const response = await fetch('https://l7rleysajb.execute-api.ap-southeast-2.amazonaws.com/prod/api/subscription/activate-key', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'UserId': userId,
        'Region': selectedRegion || 'us'
      },
      body: JSON.stringify({
        subscriptionKey: subscriptionKey.trim()
      })
    });

    const data = await response.json();

    if (response.ok) {
      // Success - show success message
      toast.success('🎉 Subscription activated successfully!');
      
      // Store subscription info if provided
      if (data.expiryDate) {
        setSubscriptionExpiryDate(data.expiryDate);
      }
      
      // Refresh subscription status
      await fetchOrgSubscriptionStatus();
      
      // Close modal
      setShowSubscriptionModal(false);
      
      // Clear the key input
      setSubscriptionKey('');
      
    } else {
      // Handle specific error messages from backend
      const errorMessage = data.error || 'Failed to activate subscription key';
      setKeyValidationError(errorMessage);
      
      // Show different messages based on error type
      if (errorMessage.includes('domain')) {
        toast.error('❌ This subscription key is not valid for your domain');
      } else if (errorMessage.includes('expired')) {
        toast.error('❌ This subscription key has expired');
      } else if (errorMessage.includes('Invalid')) {
        toast.error('❌ Invalid subscription key');
      } else {
        toast.error('❌ ' + errorMessage);
      }
    }

  } catch (error) {
    console.error('Error activating subscription:', error);
    setKeyValidationError('Network error. Please try again.');
    toast.error('❌ Network error. Please check your connection and try again.');
  } finally {
    setIsActivatingKey(false);
  }
};

const handleDemoRequest = async (e) => {
  e.preventDefault();
  setSending(true);
  
  try {
    const region = sessionStorage.getItem('userRegion') || 'GB';
    const response = await axios.post(
      'https://8dajod6f4h.execute-api.ap-southeast-2.amazonaws.com/prod/api/demo-request',
      {
        name: formData.name,
        email: formData.email,
        company: formData.company,
        message: formData.message,
        userId:  userData?.["cognito:username"],
        requestedAt: new Date().toISOString()
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Region': region,
          'UserId':  userData?.["cognito:username"]
        }
      }
    );
    
    if (response.status === 200) {
      toast.success(`Thank you ${formData.name}! We'll contact you soon.`);
      setShowDemoForm(false);
      // Reset form
      setFormData({ name: '', email: '', company: '', message: '' });
    }
  } catch (error) {
    console.error('Failed to submit demo request:', error);
    toast.error('Failed to submit demo request. Please try again.');
  } finally {
    setSending(false);
  }
};



// Add this useEffect after your other useEffect hooks
useEffect(() => {
  if (showDemoForm && userData) {
    setFormData(prev => ({
      ...prev,
      name:  userData?.name || '',
      email: userData?.email || ''
    }));
  }
}, [showDemoForm, userData]);


// Add state for subscription expiry date
const [subscriptionExpiryDate, setSubscriptionExpiryDate] = useState(null);


const validateKeyRealtime = async (key) => {
  if (!key || !isValidKeyFormat(key)) {
    return;
  }

  setIsValidatingKey(true);
  
  try {
    const response = await fetch('https://odf55el13m.execute-api.ap-southeast-2.amazonaws.com/prod/api/subscription/validate-key', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'UserId': userId,
        'Region': selectedRegion || 'us'
      },
      body: JSON.stringify({
        subscriptionKey: key.trim()
      })
    });

    const data = await response.json();

    if (response.ok) {
      setKeyValidationInfo(data);
      
      if (!data.valid) {
        setKeyValidationError('');  // Clear any previous errors, show validation info instead
      }
    } else {
      setKeyValidationInfo({
        valid: false,
        reason: data.error || 'Unable to validate key'
      });
    }

  } catch (error) {
    console.error('Error validating key:', error);
    setKeyValidationInfo({
      valid: false,
      reason: 'Network error - unable to validate key'
    });
  } finally {
    setIsValidatingKey(false);
  }
};

// Clean up timeout on component unmount
useEffect(() => {
  return () => {
    if (validationTimeout.current) {
      clearTimeout(validationTimeout.current);
    }
  };
}, []);

  return (
    <>
      <nav className="flex px-2 py-2 navbar-dash">
      <div className="navbar-left">
       
																				   
           {isSidebarCollapsed && (
          <img
          className="logoS"
            src={logo}
            alt="Logo"
            style={{  height: "35px", marginLeft: "0%" }}
          />
        )}
        {/* </Link> */}
     </div>
     
												 
														
			 
				  
     {/* Right Side: Reset Button and Profile Dropdown */}   <div className="navbar-right">
      <div className="ml-auto mt-0 text-end drop">
  {/* Unified Subscription Status - Covers ALL modules */}
  {/* Unified Subscription Status - Covers ALL modules */}
{!subscriptionLoading && (() => {
  // ✅ PRIORITY 1: Active Subscription (Highest Priority)
  if (orgSubscriptionStatus === 'active') {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="active-subscription-tooltip">
            Premium subscription active. All modules unlocked. Click to manage billing.
          </Tooltip>
        }
      >
        <span
          className="badge bg-success text-white trial-badge ms-2 mt-1 d-none d-md-inline"
          style={{
            fontSize: "0.75rem",
            padding: "6px 12px",
            borderRadius: "50rem",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          onClick={() => setShowSubscriptionModal(true)}			 
																							
        >
          ✅ PREMIUM ACTIVE
        </span>
      </OverlayTrigger>
    );
  }
  
  // ✅ PRIORITY 2: Active Trial
  if (orgSubscriptionStatus === 'trialing' && orgTrialEndDate) {
    const daysLeft = Math.floor((new Date(orgTrialEndDate + 'Z') - new Date()) / (1000 * 60 * 60 * 24));
    const hoursLeft = Math.floor((new Date(orgTrialEndDate + 'Z') - new Date()) / (1000 * 60 * 60));

						
	  
					   
										 
		  
		   
 
												
															 
				 
									  
		  
				  
			  
			  
								
	 
												 
												  
			
									
		   
					   
					  
								 
							  
		
					   
	 
					
			 
    
    // If trial expired, skip this badge
    if (daysLeft < 0 && hoursLeft < 0) {
      // Fall through to next priority
    } else {
      const displayText = daysLeft > 0 ? `${daysLeft} days left` : `${hoursLeft} hours left`;
      return (
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="org-trial-tooltip">
              Organization trial expires soon. Enter subscription key to continue seamlessly.
            </Tooltip>
		 
						
		
						  
																 
          }
					 
																						   
        >
          <span
            className="badge bg-warning text-dark trial-badge ms-2 mt-1 d-none d-md-inline"
            style={{
              fontSize: "0.75rem",
              padding: "6px 12px",
              borderRadius: "50rem",
              whiteSpace: "nowrap",
              cursor: "pointer",
            }}
            onClick={() => setShowSubscriptionModal(true)}
          >
            ⏳ Trial: {displayText}
          </span>
        </OverlayTrigger>
      );
    }
  }
  
  // ✅ PRIORITY 3: Canceled Status (Show ENTER KEY)
  if (orgSubscriptionStatus === 'canceled') {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="canceled-status-tooltip">
            Trial canceled. Enter subscription key to continue
          </Tooltip>
	 
				 
        }
      >
        <span
          className="badge bg-danger text-white trial-badge ms-2 mt-1 d-none d-md-inline"
          style={{
            fontSize: "0.75rem",
            padding: "6px 12px",
            borderRadius: "50rem",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          onClick={handleSubscriptionKeyEntry}
        >
          <Key className="me-1" size={12} />
          ENTER KEY
        </span>
      </OverlayTrigger>
    );
  }
  
  // ✅ PRIORITY 4: First-time users (Show START TRIAL)
  if (!orgSubscriptionStatus && !firstTrialUsed) {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="start-trial-tooltip">
            Start your 15-day trial to access all modules + API Integration + Privacy Compliances
          </Tooltip>
        }
      >
        <span 
          className="badge bg-primary text-white trial-badge ms-2 mt-1 d-none d-md-inline"
          style={{ 
            fontSize: '0.75rem', 
            padding: '6px 12px', 
            borderRadius: '50rem', 
            whiteSpace: 'nowrap', 
            cursor: 'pointer' 
          }}
          onClick={handleStartOrgTrial}
        >
          START TRIAL
        </span>
      </OverlayTrigger>
    );
  }
  
  // ✅ PRIORITY 5: Users with available second trial
  if (orgSubscriptionStatus !== 'canceled' && secondTrialAvailable && (firstTrialUsed || orgSubscriptionStatus)) {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="second-trial-tooltip">
            Try 15 more days ! Access all modules: API Integration & Privacy Compliances
          </Tooltip>
        }
      >
        <span
          className="badge bg-info text-white trial-badge ms-2 mt-1 d-none d-md-inline"
          style={{
            fontSize: "0.75rem",
            padding: "6px 12px",
            borderRadius: "50rem",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          onClick={handleStartSecondTrial}
        >
          🆕 TRY 15 MORE DAYS
								  
																						  
									 
	   
												
															 
									 
	   
	  
					   
												  
        </span>
      </OverlayTrigger>
    );
  }
  
  // ✅ PRIORITY 6: Revoked users (exhausted trials)
  if (!orgSubscriptionStatus && (firstTrialUsed || secondTrialUsed)) {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="revoked-tooltip">
            Trial period expired. Enter a subscription key to continue.
          </Tooltip>
								
										 
											   
									
			
        }
      >
        <span 
          className="badge bg-secondary text-white trial-badge ms-2 mt-1 d-none d-md-inline"
          style={{ 
            fontSize: '0.75rem', 
            padding: '6px 12px', 
            borderRadius: '50rem', 
            whiteSpace: 'nowrap', 
            cursor: 'pointer' 
          }}
          onClick={handleSubscriptionKeyEntry}
        >
          ENTER KEY
        </span>
      </OverlayTrigger>
    );
  }
  
  // ✅ DEFAULT: No badge
  return null;
})()}

									   
							  
						  



</div>
<OverlayTrigger
    placement="bottom"
    overlay={
      <Tooltip id="info-tooltip" style={{ zIndex: 99999 }}>
        Knowledge Base
      </Tooltip>
    }
  >
    <button
      type="button"
      onClick={() => window.open("https://kb.srql.com", "_blank")}
      className="text-white rounded-circle border-0 d-flex align-items-center justify-content-center"
      style={{
       
        cursor: "pointer",
        marginRight:"-39px",
        backgroundColor: "transparent",  
 
      }}
    >
    <Info size={26} color="white" />
    </button>
  </OverlayTrigger>

  <div style={{
    marginRight:"10px"
  }} >

<OverlayTrigger
        placement="bottom" // Position of the tooltip
        overlay={<Tooltip id="ask-tooltip"  style={{ zIndex: 99999 }}>Play Video</Tooltip> }
        >
<buttom
  onClick={() => setShowVideoModal(true)}
  className=" videos text-white rounded-circle border-0 d-flex align-items-center justify-content-center"
  style={{ width: "30px", height: "30px" , }}
>
  {/* ▶️ */}  <Play size={26} color="white" />

</buttom>
</OverlayTrigger>
</div>

{/* 🎥 Video Modal */}
<Modal
  show={showVideoModal}
  onHide={() => setShowVideoModal(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton className="demobtn">
    <Modal.Title>ServQual SUSAN Training & Demo</Modal.Title>
  </Modal.Header>
  <Modal.Body className="text-center">
   <iframe
  width="100%"
  height="400"
  src="https://www.youtube.com/embed/EvUIHP_0F4s?autoplay=1&mute=1&playsinline=1"
  title="ServQual SUSAN Training Demo"
  frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowFullScreen
  style={{ borderRadius: "10px" }}
></iframe>

    {/* 🟩 Request Demo Button */}
    <Button
      variant="success"
      onClick={() => {
        setShowVideoModal(false);
        setShowDemoForm(true);
      }}
      className=" mt-1"
    >
      Request a Demo
    </Button>
    
  </Modal.Body>
</Modal>
{/*  Demo Request Modal */}
<Modal show={showDemoForm} onHide={() => setShowDemoForm(false)} centered>
  <Modal.Header closeButton className="demobtn">
    <Modal.Title>Request a Demo</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <form onSubmit={handleDemoRequest}>
      <div className="mb-3">
        <label className="form-label fw-semibold">Full Name</label>
        <input
          type="text"
          className="form-control"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
          placeholder="Enter your full name"
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Email Address</label>
        <input
          type="email"
          className="form-control"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
          placeholder="Enter your email"
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Company / Organization</label>
        <input
          type="text"
          className="form-control"
          value={formData.company}
          onChange={(e) => setFormData({ ...formData, company: e.target.value })}
          placeholder="Enter company name (optional)"
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Message</label>
        <textarea
          className="form-control"
          rows="3"
          placeholder="Tell us about your requirements"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        />
      </div>

      <div className="d-flex justify-content-end">
        <Button 
          variant="secondary" 
          onClick={() => setShowDemoForm(false)}
          disabled={sending}
        >
          Cancel
        </Button>
        <Button 
          type="submit" 
          variant="primary" 
          className="ms-2"
          disabled={sending}
        >
          {sending ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Sending...
            </>
          ) : (
            'Submit Request'
          )}
        </Button>
      </div>
    </form>
  </Modal.Body>
</Modal>


 

{/* ASK SUSAN Button */}
<div className="ms-md-4 mt-3 mt-md-0 text-center text-md-start">
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="ask-tooltip" style={{ zIndex: 99999 }}>ASK SUSAN</Tooltip>}
  >
    <Button
      onClick={() => setShowQBotModal(true)}
      variant="null"
      className="asksusan "
      style={{
        color:"white",
        marginRight:"0px"        
      }}
    >
      <Bot size={30} />
    </Button>
  </OverlayTrigger>

  {/* SUSAN Chatbot Modal - NEW */}
  <SusanChatbot
    show={showQBotModal}
    onHide={() => setShowQBotModal(false)}
    userId={userData?.name}
  />
</div>




	  

       {/* 🔔 ADD NOTIFICATION BELL ICON HERE: */}
        <div className="ml-auto mt-0 text-end drop">
       <OverlayTrigger
       placement="bottom"
       overlay={
       <Tooltip id="notification-tooltip" style={{ zIndex: 99999 }}>
        {/* 🚀 UPDATE THIS TOOLTIP */}
        {totalNotificationCount > 0 
          ? `${totalNotificationCount} total notifications (${notifications.length} pending requests, ${requesterNotifications.filter(n => n.status === 'unread').length} status updates)` 
          : 'No notifications'}
         </Tooltip>
        }
        >
    <div
      className="position-relative"
      style={{ cursor: "pointer" }}
      onClick={() => setShowNotificationModal(true)}
    >
      <Bell size={24} className="text-white" />
      
      {/* ✅ This badge code is correct - keep it as is */}
      {totalNotificationCount > 0 && (
        <Badge
          bg="danger"
          className="position-absolute top-0 start-100 translate-middle rounded-pill"
          style={{ fontSize: "0.7rem" }}
        >
          {totalNotificationCount > 99 ? '99+' : totalNotificationCount}
        </Badge>
      )}
    </div>
  </OverlayTrigger>
</div>

        {/* Reset Modules Dropdown */}
        <div className="ml-auto mt-0 text-end drop">
          <Dropdown align="left">
          <OverlayTrigger
        placement="bottom" // Position of the tooltip
        overlay={<Tooltip id="reset-tooltip"  style={{ zIndex: 99999 }}>Reset</Tooltip> }
        >
            <Dropdown.Toggle
              id="reset-dropdown"
              className="border-0 bg-transparent p-0  custom-toggle text-white"
            >
              <img
              className="ResetButton"
                src={reload}
                alt="Reset"
               
              />
            </Dropdown.Toggle>
            </OverlayTrigger>
            <Dropdown.Menu className="dropdown-menu-right mt-3 shadow-lg p-2">
            <Dropdown.Item
              as="button"
              onClick={() => handleResetModule("GenAI")}
            >
              Reset GenAI
            </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => handleResetModule("AWS")}
              >
                Reset AWS (All Submodules)
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => handleResetModule("Entra")}
              >
                Reset Entra (All Submodules)
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => handleResetModule("GoogleCloud")}
              >
                Reset Google Cloud (All Submodules)
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => handleResetModule("M365")}
              >
                Reset M365 (All Submodules)
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => handleResetModule("BlockchainSecurity")}
              >
                Reset Blockchain Security
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => handleResetModule("ISO27001Compliance")}
              >
                Reset ISO 27001 Compliance
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => handleResetModule("PrivacyDataProtectionCompliance")}
              >
                Privacy/Data Protection Compliance
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => handleResetModule("CISSecurity")}
              >
                Reset CIS Security
              </Dropdown.Item>
              {/* Reset All Modules */}
              <Dropdown.Item
                as="button"
                className="text-danger font-weight-bold"
                onClick={() => handleResetModule("AllModules")}
              >
                Reset All Modules (CAUTION)
              </Dropdown.Item>
               <Dropdown.Item as="button" className="text-danger font-weight-bold" onClick={handleResetDashboard}>
                Reset Dashboard
                </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        
        </div>

        {/* Dropdown aligned to the right */}
        <div className="ml-auto mt-4 text-end drop">
          <Dropdown align="right">
            <Dropdown.Toggle
              id="user-dropdown"
              className="border-0 bg-transparent p-0 custom-toggle"
            >
              <div className="flex items-center justify-center text-white bg-transparent mb-4">
                <span className="text-purple-600 font-bold text-lg avatar">
                  {userAttributes.username?.charAt(0).toUpperCase() || "U"}
                </span>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-menu-right userBox shadow-lg p-2">
              <div className="d-flex flex-row p-3">
                <span className="font-bold text-lg avatar-dropdown">
                  {userAttributes.username?.charAt(0).toUpperCase() || "U"}
                </span>
                <div className="d-flex flex-column navbar-icon">
                  <strong>
                    <span className="text-muted">
                      {capitalizeFirstLetter(userAttributes.username) ||
                        "No Username"}
                    </span>
                  </strong>
                  <span className="text-muted">
                    {userAttributes.email || "No Email"}
                  </span>
                </div>
              </div>
              <Dropdown.Divider />
              {/* Reset Password Link */}
              {/* {role?.includes("Admin") && (
  <Dropdown.Item
    as="button"
    className="d-flex align-items-center text-secondary"
    onClick={() => navigate("/manage-users")}
  >
    <Settings className="me-2" size={18} />
    Manage Users
  </Dropdown.Item>
)} */}
{role?.includes("Admin") && (
  <Dropdown.Item
  as="button"
  className="d-flex align-items-center text-secondary"
  onClick={() => navigate("/settings")}
>
  <Settings className="me-2" size={18} />
  Settings
</Dropdown.Item>
 
)}
 {/* <Dropdown.Item
    as="button"
    className="d-flex align-items-center text-secondary"
    onClick={() => navigate("/settings", { state: { activeTab: "access-logs" } })}
  >
    <ClipboardList className="me-2" size={18} />
    Access Logs
  </Dropdown.Item> */}


{/* ✅ ADD THIS — Settings */}
{/* <Dropdown.Item
  as="button"
  className="d-flex align-items-center text-secondary"
  onClick={() => navigate("/settings")}
>
  <Settings className="me-2" size={18} />
  Settings
</Dropdown.Item> */}

              <Dropdown.Item
                as="button"
                className="d-flex align-items-center text-primary"
                onClick={handleResetPassword}
              >
                Reset Password
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                className="d-flex align-items-center text-danger"
                onClick={handleSignOut}
              >
                <LogOut className="me-2" />
                Log out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        </div>
      </nav>
      {/* Warning Modal */}
      <Modal show={showWarningModal} onHide={handleCancelReset}>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>CAUTION:</strong> You are about to reset {moduleToReset === "AllModules" ? "all modules" : `the ${moduleToReset} module`}! This action
            will permanently delete your responses.
          </p>
          <p>Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
           <Button variant="secondary" onClick={() => setShowWarningModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleConfirmResetModule} disabled={isResetting}>
            {isResetting ? (<><Spinner animation="border" size="sm" className="me-2" /> Resetting...</>) : "Continue"}
          </Button>
        </Modal.Footer>
      </Modal>

 {/* Warnin Dashboard Modal */}
      <Modal show={showDashboardResetModal} onHide={() => setShowDashboardResetModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Warning</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p>
      <strong>CAUTION:</strong> You are about to reset your entire <strong>Dashboard</strong> status. This will erase
      your assessment progress and AI insights.
    </p>
    <p>Are you sure you want to continue?</p>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowDashboardResetModal(false)}>
      Cancel
    </Button>
    <Button variant="danger" onClick={confirmResetDashboard} disabled={isResetting}>
      {isResetting ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" /> Resetting...
        </>
      ) : (
        "Continue"
      )}
    </Button>
  </Modal.Footer>

</Modal>

{/* 🚀 UPDATE the notification modal in your JSX */}
<Modal
  show={showNotificationModal}
  onHide={() => setShowNotificationModal(false)}
  size="lg"
  centered
  dialogClassName="notifications-modal"
 
  /* ✅ NEW: improve default keyboard/focus behavior */
  keyboard={true}          // ensure Esc works (usually default)
  enforceFocus={true}      // keep focus inside the modal
  restoreFocus={true}      // return focus to the trigger on close
  autoFocus={true}         // autofocus modal on open
 
  /* ✅ NEW: unique hook to find modal content for focus trap */
  contentClassName="notifications-modal-content"
 
  /* ✅ NEW: attach focus trap when modal has fully opened */
  onEntered={() => {
    const modalEl = document.querySelector(".notifications-modal-content");
    if (!modalEl) return;
 
    // Optional UX: lock background scroll
    window.__notif_prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
 
    const selectors =
      'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
 
    const isVisible = (el) => {
      const s = window.getComputedStyle(el);
      return s.display !== "none" && s.visibility !== "hidden" && el.offsetParent !== null;
    };
 
    const getFocusables = () =>
      Array.from(modalEl.querySelectorAll(selectors)).filter(isVisible);
 
    let focusables = getFocusables();
    const first = () => (focusables = getFocusables(), focusables[0]);
    const last  = () => (focusables = getFocusables(), focusables[focusables.length - 1]);
 
    // Initial focus (first focusable or modal itself)
    (first() || modalEl).focus?.();
 
    // Keydown handler to loop Tab within modal
    const onKeyDown = (e) => {
      if (e.key !== "Tab") return;
 
      focusables = getFocusables();
      if (focusables.length === 0) {
        e.preventDefault();
        return;
      }
 
      const active = document.activeElement;
 
      // Shift+Tab on first -> jump to last
      if (e.shiftKey && active === first()) {
        e.preventDefault();
        last()?.focus?.();
        return;
      }
      // Tab on last -> jump to first
      if (!e.shiftKey && active === last()) {
        e.preventDefault();
        first()?.focus?.();
        return;
      }
    };
 
    // Attach with capture to avoid outside handlers interfering
    document.addEventListener("keydown", onKeyDown, { capture: true });
    // store for cleanup
    window.__notifTrap = onKeyDown;
  }}
 
  /* ✅ NEW: cleanup focus trap & scroll lock */
  onExit={() => {
    if (window.__notifTrap) {
      document.removeEventListener("keydown", window.__notifTrap, { capture: true });
      window.__notifTrap = null;
    }
    if (window.__notif_prevOverflow !== undefined) {
      document.body.style.overflow = window.__notif_prevOverflow;
      delete window.__notif_prevOverflow;
    }
  }}
>
  <Modal.Header closeButton className="Notify text-white">
    <Modal.Title className="notify-title">
      <div className="notify-header">
        <div className="notify-left">
          <Bell className="notify-bell" />
          <span className="notify-text">Notification Settings </span>
          <Badge bg="light" text="dark" className="notify-badge">
            {totalNotificationCount} total
          </Badge>
 
          {notificationPermission !== "granted" && (
            <Button
              variant="none"
              size="sm"
              className="Notify1"
              onClick={requestNotificationPermission}
            >
              <Bell size={16} className="me-2" />
              Enable Notifications
            </Button>
          )}
        </div>
      </div>
    </Modal.Title>
  </Modal.Header>
  <Modal.Body className="bg-light">
<Row className="mb-3 ">
  <Col>
    <div className=" navbarnotification">
     
      {/* Email Notifications */}
      <div className="mb-4">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Form.Check
  type="switch"
  id="email-notifications-switch"
  label="Enable email alerts for critical risks"
  checked={emailNotificationEnabled}
  onChange={async (e) => {
    const value = e.target.checked;
    setEmailNotificationEnabled(value);
    saveNotificationSettings({ emailEnabled: value });
  }}
  className="me-3"
/>

            <small className="text-muted notificationEmail">
              Email: <strong>{userData?.email}</strong>
            </small>
          </div>
        </div>
      </div>
 
      {/* Mobile SMS Notifications */}
 
     {/* Mobile SMS Notifications */}
      <div className="mb-3">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <Form.Check
  type="switch"
  id="sms-notifications-switch"
  label="Enable SMS alerts for critical risks"
  checked={pushNotificationEnabled}
  onChange={async (e) => {
    const value = e.target.checked;
    setPushNotificationEnabled(value);
    saveNotificationSettings({ smsEnabled: value });
  }}
  className="me-3"
/>

        </div>
       
        {pushNotificationEnabled && (
          <div className="border rounded p-3  notifydiv ">
            <div className="">
              <div className="">
                <Form.Group>
                  <Form.Label className="small text-muted mb-1">
                    Mobile Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Enter mobile number (e.g., +1234567890)"
                    value={userPhoneNumber}
                    onChange={(e) => setUserPhoneNumber(e.target.value)}
                    isInvalid={userPhoneNumber && !validatePhoneNumber(userPhoneNumber)}
                    disabled={!pushNotificationEnabled}
                  />
                  <Form.Control.Feedback type="invalid" >
                    Please enter a valid phone number in international format (e.g., +1234567890)
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted">
                    Include country code (e.g., +1 for US, +44 for UK, +91 for India)
                  </Form.Text>
                </Form.Group>
              </div>
              <div className="col-md-4 d-flex align-items-end">
                <div className="d-flex gap-2 w-100">
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handlePhoneNumberAction}
                    disabled={!userPhoneNumber || !validatePhoneNumber(userPhoneNumber) || isUpdatingPhone}
                     className="save"
                  >
                    {isUpdatingPhone ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Saving...
                      </>
                    ) : (
                      localStorage.getItem('userPhoneNumber') ? 'Update' : 'Save'
                    )}
                  </Button>
                 
                  {userPhoneNumber && validatePhoneNumber(userPhoneNumber) && (
                    <Button
                      variant="outline-success"
                      size="sm"
                      onClick={sendTestSMS}
                      disabled={isUpdatingPhone}
                      className="testsms"
                    >
                      📱 Test SMS
                    </Button>
                  )}
                </div>
              </div>
            </div>
 
            {/* Current saved phone number display */}
            {localStorage.getItem('userPhoneNumber') && (
              <div className="small text-success">
                ✅ Saved number: <strong>{localStorage.getItem('userPhoneNumber')}</strong>
              </div>
            )}
          </div>
        )}
      </div>


 
 
 
         
      {/* Status Messages */}
      {!emailNotificationEnabled && !pushNotificationEnabled && (
        <div className="p-2 bg-warning-subtle border border-warning rounded">
          <small className="text-warning-emphasis">
            ⚠️ All critical risk notifications are currently disabled
          </small>
        </div>
      )}
 
      {pushNotificationEnabled && !userPhoneNumber && (
        <div className="p-2 bg-info-subtle border border-info rounded">
          <small className="text-info-emphasis">
            ℹ️ Please enter and save your mobile number to receive SMS notifications
          </small>
        </div>
      )}
    </div>
  </Col>
</Row>
 
 
    <div className="row">
      {/* Notifications Section */}
      <div className="col-md-12">
        <ul className="nav nav-tabs mb-3 pendingStatus">
          <li className="nav-item ">
            <button
              className={`nav-link ${activeTab === 'pending' ? 'active' : ''}`}
              onClick={() => setActiveTab('pending')}
            >
              Pending ({notifications.length})
            </button>
          </li>
          <li className="nav-item ">
            <button
              className= {`nav-link ${activeTab === 'status' ? 'active' : ''}`}
              onClick={() => setActiveTab('status')}
            >
              Status ({requesterNotifications.filter(n => n.status === 'unread').length})
            </button>
          </li>
        </ul>
 
        <div className="tab-content" style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {activeTab === 'pending' && (
            <div>
              {notifications.length > 0 ? (
                notifications.map((req) => (
                  <div key={req.requestId} className="p-3 mb-3 rounded bg-white shadow-sm hover-card">
                    <div className="d-flex justify-content-between">
                      <div>
                        <strong>{req.contactPerson}</strong>
                        <br />
                        <small className="text-muted">{req.requesterEmail}</small>
                        <br />
                        <small className="text-muted">{req.departmentName}</small>
                      </div>
                      <Badge bg="warning" text="dark">Pending</Badge>
                    </div>
                    {req.reason && <p className="mt-2"><strong>Reason:</strong> {req.reason}</p>}
                    <small className="text-muted d-block mb-2">
                      Requested: {new Date(parseInt(req.requestedAt)).toLocaleDateString()}
                    </small>
                    <div className="d-flex gap-2">
                      <Button size="sm" variant="success" onClick={() => handleApproveRequest(req)}>✅ Approve</Button>
                      <Button size="sm" variant="danger" onClick={() => handleDenyRequest(req)}>❌ Deny</Button>
                    </div>
                  </div>
                ))
              ) : (
               
                <div className="text-center py-4">
                  <Bell size={48} className="text-muted mb-3" />
                  <p className="text-muted">No pending requests</p>
                </div>
              )}
            </div>
          )}
 
          {activeTab === 'status' && (
            <div>
              {requesterNotifications.length > 0 ? (
                requesterNotifications.map((n) => (
                  <div key={n.notificationId} className={`p-3 mb-3 rounded bg-white shadow-sm hover-card ${n.status === 'unread' ? 'border-primary' : ''}`}>
                    <div className="d-flex justify-content-between">
                      <div>
                        <strong>{n.title}</strong>
                        <br />
                        <small className="text-muted">{n.message}</small>
                      </div>
                      <Badge bg={n.type === 'APPROVAL' ? 'success' : 'danger'}>
                        {n.type}
                      </Badge>
                    </div>
                    <small className="text-muted d-block mb-2">{new Date(parseInt(n.createdAt)).toLocaleDateString()}</small>
                    {n.status === 'unread' && (
                      <Button size="sm" variant="outline-primary" onClick={() => markNotificationAsRead(n.notificationId)}>
                        Mark as Read
                      </Button>
                    )}
                  </div>
                ))
              ) : (
                <div className="text-center py-4">
                  <Bell size={48} className="text-muted mb-3" />
                  <p className="text-muted">No status updates</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  </Modal.Body>
 
 
  <Modal.Footer>
    <Button variant="outline-primary" onClick={fetchNotifications}>🔄 Refresh</Button>
    {/* <Button variant="secondary" onClick={() => setShowNotificationModal(false)}>Close</Button> */}
  </Modal.Footer>
</Modal>
{/* Subscription Key Modal */}
{/* Enhanced Subscription Key Modal with Real-time Validation */}
<Modal show={showSubscriptionModal} onHide={() => setShowSubscriptionModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title className="d-flex align-items-center">
      <Key className="me-2" size={24} />
      Subscription Management
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {orgSubscriptionStatus === 'active' ? (
      <div className="text-center">
        <div className="mb-3">
          <Badge bg="success" className="p-2 fs-6">
            ✅ Premium Subscription Active
          </Badge>
        </div>
        <p className="text-muted">
          Your subscription is active with full access to all modules and features.
        </p>
        {subscriptionExpiryDate && (
          <p className="small text-muted">
            <strong>Expires:</strong> {new Date(subscriptionExpiryDate).toLocaleDateString()}
          </p>
        )}
      </div>
    ) : (
      <div>
        <div className="mb-4">
          <h6>Enter Subscription Key</h6>
          <p className="text-muted small">
            Enter your subscription key to activate premium features and access all modules.
          </p>
        </div>
        
        <Form.Group className="mb-3">
          <Form.Label>Subscription Key <span className="text-danger">*</span></Form.Label>
          <div className="position-relative">
            <Form.Control
              type="text"
              placeholder=""
              value={subscriptionKey}
              onChange={(e) => {
                const value = e.target.value.trim();
                setSubscriptionKey(value);
                setKeyValidationError('');
                setKeyValidationInfo(null);
                
                // Trigger validation after user stops typing
                clearTimeout(validationTimeout.current);
                validationTimeout.current = setTimeout(() => {
                  if (value && isValidKeyFormat(value)) {
                    validateKeyRealtime(value);
                  }
                }, 1000); // Validate after 1 second of no typing
              }}
              isInvalid={!!keyValidationError}
              disabled={isActivatingKey}
              className="text-monospace"
            />
            
            {/* Real-time validation indicator */}
            {isValidatingKey && (
              <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                <Spinner animation="border" size="sm" />
              </div>
            )}
          </div>
          
          <Form.Control.Feedback type="invalid">
            {keyValidationError}
          </Form.Control.Feedback>
          
          <Form.Text className="text-muted">
            <small>Enter your complete subscription key </small>
          </Form.Text>
        </Form.Group>

        {/* Key validation info display */}
        {keyValidationInfo && (
          <div className={`alert ${keyValidationInfo.valid ? 'alert-success' : 'alert-danger'} py-2`}>
            {keyValidationInfo.valid ? (
              <div>
                <div className="d-flex align-items-center mb-1">
                  <CheckCircle className="me-2" size={16} />
                  <strong>Valid Subscription Key</strong>
                </div>
                <small>
                  <strong>Customer:</strong> {keyValidationInfo.customerName}<br/>
                  <strong>Domain:</strong> {keyValidationInfo.domainName}<br/>
                  <strong>Expires:</strong> {new Date(keyValidationInfo.expiryDate).toLocaleDateString()}<br/>
                  <strong>Region:</strong> {keyValidationInfo.countryCode}
                </small>
              </div>
            ) : (
              <div className="d-flex align-items-center">
                <XCircle className="me-2" size={16} />
                <span><strong>Invalid Key:</strong> {keyValidationInfo.reason}</span>
              </div>
            )}
          </div>
        )}

       

        <div className="bg-light p-3 rounded mb-3">
          <h6 className="small mb-2">📧 Need a Subscription Key?</h6>
          <p className="small mb-0">
            If you don't have a subscription key, please contact <strong>susan@srql.com</strong>.
          </p>
        </div>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowSubscriptionModal(false)}>
      Close
    </Button>
    {orgSubscriptionStatus !== 'active' && (
      <Button 
        variant="primary" 
        onClick={handleActivateSubscriptionKey}
        disabled={isActivatingKey || !subscriptionKey.trim() || !isValidKeyFormat(subscriptionKey) || (keyValidationInfo && !keyValidationInfo.valid)}
      >
        {isActivatingKey ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Activating...
          </>
        ) : (
          'Activate Subscription'
        )}
      </Button>
    )}
  </Modal.Footer>
</Modal>




<ToastContainer
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
/>

    </>
    
  );
};

export default NavigationBar;
